// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fRDpN7GqE1y13nxaq6CA{background:var(--background-primary-inverted-primary);width:260px;box-shadow:var(--menu-shadow);border-radius:8px;flex-direction:column;display:flex}.fRDpN7GqE1y13nxaq6CA.KGH270U0C8Y7saT3UOvA{width:310px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownWrapper": `fRDpN7GqE1y13nxaq6CA`,
	"full": `KGH270U0C8Y7saT3UOvA`
};
export default ___CSS_LOADER_EXPORT___;
